import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";
import Home from "../views/Home.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/order",
      children: [
        {
          path: "",
          name: "Menues",
          component: () => import("../views/order/Menues.vue"),
          meta: {},
        },
        {
          path: "new/:type",
          name: "ConfigureNew",
          component: () => import("../views/order/ConfigureDish.vue"),
          meta: {
            showBackLink: true,
          },
        },
        {
          path: "configure/:type/:id",
          name: "ConfigureExisting",
          component: () => import("../views/order/ConfigureDish.vue"),
          meta: {
            showBackLink: true,
          },
        },
        {
          path: "configure/:type/:id/ingredients",
          name: "ConfigureIngredients",
          component: () => import("../views/order/ConfigureDishIngredients.vue"),
          meta: {
            showBackLink: true,
          },
        },
        {
          path: "payment",
          name: "Payment",
          component: () => import("../views/order/Payment.vue"),
          meta: {
            showBackLink: true,
          },
        },
        {
          path: "thankyou",
          name: "ThankYou",
          component: () => import("../views/order/Thankyou.vue"),
          meta: {
            showBackLink: true,
          },
        },
      ],
    },
    {
      path: "/kitchen",
      children: [
        {
          path: "",
          name: "Kitchen",
          component: () => import("../views/kitchen/Index.vue"),
          meta: {
            requireAuth: true,
          },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/Login.vue"),
    },
  ],
});

router.beforeEach(async (to) => {
  const authRequired = to.meta.requireAuth;
  const auth = useAuthStore();

  if (authRequired && !auth.isAuthenticated) {
    auth.returnUrl = to.fullPath;
    return "/login";
  }
});

export default router;
